import { Component } from '@angular/core';

@Component({
  selector: 'app-refresh',
  template: ``,
  standalone: false,
})
export class RefreshComponent {}
